export const hasPrices = (inputs) => inputs.some((input) => !!input.priceDescription);
